export class SaasWorkloadCoverage {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "totalItems",
            "baseName": "totalItems",
            "type": "number",
            "format": "int64"
        },
        {
            "name": "totalBytes",
            "baseName": "totalBytes",
            "type": "number",
            "format": "int64"
        },
        {
            "name": "completeEntityCount",
            "baseName": "completeEntityCount",
            "type": "number",
            "format": "int64"
        },
        {
            "name": "budgetExceededItems",
            "baseName": "budgetExceededItems",
            "type": "number",
            "format": "int64"
        },
        {
            "name": "runDeadlineExceededItems",
            "baseName": "runDeadlineExceededItems",
            "type": "number",
            "format": "int64"
        },
        {
            "name": "accessDeniedItems",
            "baseName": "accessDeniedItems",
            "type": "number",
            "format": "int64"
        },
        {
            "name": "readErrorItems",
            "baseName": "readErrorItems",
            "type": "number",
            "format": "int64"
        }
    ];
    static getAttributeTypeMap() {
        return SaasWorkloadCoverage.attributeTypeMap;
    }
    constructor() {
    }
}
